import React, { Component } from "react";
import Datetime from "react-datetime";
import { observer } from "mobx-react";
import "./react-datetime.css";
import moment from "moment";
import { FormControl } from "react-bootstrap";

class Date extends Component {
  isValidDate(date) {
    const { isValidDate } = this.props;
    let valid = true;
    if (isValidDate) {
      valid = isValidDate(date);
    }
    return valid;
  }

  handleOnChangeDate(newDateTime) {
    const { model, dataMember, onChange } = this.props;

    const oldDate = model[dataMember];
    if (model && dataMember) {
      if (newDateTime instanceof moment) {
        // if the model wants it as date, keep it like this
        if (model.parseAsDate(dataMember)) {
          model[dataMember] = newDateTime.clone();
        } else {
          // otherwise format back as a string
          model[dataMember] = newDateTime.format();
        }
      } else {
        model[dataMember] = null;
      }
    }

    if (onChange) {
      onChange(newDateTime, oldDate);
    }
  }

  render() {
    const { model, dataMember, readOnly, placeholder, timeFormat } = this.props;

    let value = null;
    if (model && dataMember) {
      value = model[dataMember];
    }

    let output = null;

    if (readOnly) {
      let dateString = "";

      if (value) {
        dateString = moment(value).format("L");

        if (timeFormat) dateString = moment(value).format("L LTS");

        if (typeof value === "string") {
          value = moment(value);
        }
      }

      output = (
        <div className="rdt">
          <FormControl readOnly value={dateString} placeholder={placeholder} />
        </div>
      );
    } else {
      output = <Datetime value={value} timeFormat={false} onChange={this.handleOnChangeDate.bind(this)} isValidDate={this.isValidDate.bind(this)} />;
    }

    return output;
  }
}

export default observer(Date);



// WEBPACK FOOTER //
// ./src/Core/Components/Inputs/Date/index.js